import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { IMAGE_URL } from 'app/constants';
import { RestService } from 'app/shared/rest.service';
import { environment } from 'environments/environment';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-ultpack',
  templateUrl: './ultpack.component.html',
  styleUrls: ['./ultpack.component.scss']
})
export class UltpackComponent implements OnInit {
  IMAGE_URL = IMAGE_URL;
  productData : any;
  modelDesign : any;
  images : any;
  iframe : any;
  urlParams : any = {};
  webAliasData: any;
  products: any;
  BucketUrl = environment.BucketURl;
  constructor(
    private _restService: RestService,
    private _toastr: ToastrService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.setDynamicBackground();
    this.callApi();
    this.urlParams = new URLSearchParams(window?.location?.search);
    this.webAliasData = this.urlParams.get('giftcard') || sessionStorage.getItem('giftCardName');
    this.products = this.urlParams.get('products');
    if (this.products) {
      window.localStorage.setItem('products', this.products);
      this.urlParams.delete('products');
      window.location.href = window.location.origin + window.location.pathname;
    }
    else {
      this.products = window.localStorage.getItem('products');
    }

  }

  setDynamicBackground(): void {
    const imageUrl1 = `${IMAGE_URL}/images/ultpackLanding/Hero-bg-img.png`;
    const imageUrl2 = `${IMAGE_URL}/images/ultpackLanding/Check-Icon.svg`;
    document.documentElement.style.setProperty('--dynamic-bg-url1', `url(${imageUrl1})`);
    document.documentElement.style.setProperty('--dynamic-bg-url2', `url(${imageUrl2})`);
  }
callApi() {
  const request = {
    'EnrollmentType': '',
    'CustomerType': 22,
    'WebCategoryId': '',
    'isUpgradeCustomer': false,
    'IsSubscriptionOrder': false,
    'PriceType': ''
};
this._restService.getProducts(request).subscribe((res: any) => {
    if (res) {
        this.productData = res;
       } else {
        this._toastr.error('Error');
    }
}, error => {
    this._toastr.error(error.error.Message, 'Error');
});
}

openModel(id) {
  while (document.getElementById("add_after_me").nextElementSibling) {
    console.log(document.getElementById("add_after_me").nextElementSibling);
    document.getElementById("add_after_me").nextElementSibling.remove();
    console.log(document.getElementById("add_after_me").nextElementSibling);
  }

  if (id) {
    this.productData.Items.filter((item) => {
      if (item.ItemCode == id) {
        console.log("LongDetail2",item.LongDetail2);
        this.modelDesign = item.LongDetail2;
        return;
      }
    });

    document
      .getElementById("add_after_me")
      .insertAdjacentHTML("afterend", this.modelDesign);
  }

  document.getElementById("myModal").style.display = "block";
  var styles = {
    margin : "auto",
  };
  $(".image").css(styles);
}

displayNone()
{
  document.getElementById('myModal').style.display='none';
}

expansionPanel() {
  if (
    document.getElementById("opendropdown").classList.contains("v-open") &&
    document.getElementById("expansionIcon").classList.contains("expandicon")
  ) {
    console.log("in this panel first");
    document.getElementById("opendropdown").classList.remove("v-open");
    document.getElementById("opendropdown").classList.add("v-close");
    document
      .getElementById("expansionIcon")
      .classList.replace("expandicon", "notexpandicon");
  } else {
    document.getElementById("opendropdown").classList.remove("v-close");
    document.getElementById("opendropdown").classList.add("v-open");
    document.getElementById("expansionIcon").classList.add("expandicon");
  }
}

goToLink()
{
  var queryString = this.webAliasData && this.products ? ("?giftcard=" + this.webAliasData + "&products=" + this.products + "&site=ultpack") : (this.webAliasData ? "?giftcard=" + this.webAliasData + "&site=ultpack": this.products ? "?products=" + this.products + "&site=ultpack": "?site=ultpack" );
  var strLink =((window.location.hostname.search('wsicloud.net') > -1 || window.location.hostname.search('localhost') > -1 || window.location.hostname.search('127.0.0.1') > -1 ) ? "https://phpenroll.wsicloud.net/AllProducts" : "https://customer.puriumenrollment.com/AllProducts") + queryString ;
  this.router.navigateByUrl('/AllProducts'+queryString);
}

}
